import { Geometry } from "ol/geom";
import { Feature, getUid } from "ol";
import { MapMarkerNewListItem } from "./Map-marker-new-list-item";
import { useContext, useState } from "react";
import { MapMarkerConfirmDelete } from "./Map-marker-confirm-delete";
import { NewFeatureListContext } from "./Map-marker-list-wrapper";

interface Props {
	items: Feature<Geometry>[];
}

export const MapMarkerNewFeatureList = (props: Props) => {
	const [checkedList, setCheckedList] = useState<string[]>([]);
	const [showDelete, setShowDelete] = useState<string | number>(0);

	const { onDelete } = useContext(NewFeatureListContext);

	const toggleCheckedAll = () => {
		if (checkedList.length === props.items.length) {
			setCheckedList([]);
		} else {
			setCheckedList(props.items.map((i) => getUid(i)));
		}
	};

	const toggleItem = (uid: string) => {
		if (checkedList.includes(uid)) {
			setCheckedList(checkedList.filter((v) => v !== uid));
		} else {
			setCheckedList([...checkedList, uid]);
		}
	};

	const handleDelete = () => {
		const list = [...checkedList, showDelete];
		onDelete(props.items.filter((i) => list.includes(getUid(i))));
		setShowDelete(0);
	};

	return (
		<div className="rounded-md border border-gray-300/60 overflow-y-auto bg-gray-50 text-sm max-h-96 w-full">
			<table className="table-fixed border-gray-300/60 rounded-md rounded-tr-md bg-white w-full">
				<thead className="border-collapse sticky top-0 bg-white border-b">
					<tr>
						<th className="h-10 2xl:w-10 w-8 overflow-hidden">
							<input onChange={toggleCheckedAll} checked={props.items.length > 0 && !props.items.find((i) => !checkedList.includes(getUid(i)))} type="checkbox" />
						</th>
						<th className="border-l text-left min-w-[3rem] 2xl:min-w-[10rem] px-2 whitespace-nowrap overflow-hidden text-ellipsis">
							<p className="font-semibold">Lineārā reference</p>
						</th>
						<th className="border-l text-left min-w-[3rem] 2xl:min-w-[10rem] px-2 whitespace-nowrap overflow-hidden text-ellipsis">
							<p className="font-semibold">Adrese</p>
						</th>
						<th className="border-l text-left min-w-[3rem] 2xl:min-w-[10rem] px-2 whitespace-nowrap overflow-hidden text-ellipsis">
							<p className="font-semibold">Koordinātas</p>
						</th>
						<th className="border-l text-left w-12 2xl:w-16"></th>
					</tr>
				</thead>
				<tbody>
					{props.items.map((item) => {
						const uid = getUid(item);

						return (
							<MapMarkerNewListItem
								checked={checkedList.includes(uid)}
								onCheck={() => toggleItem(uid)}
								onDelete={() => setShowDelete(uid)}
								key={uid + item.get("trigger")}
								item={item}
							/>
						);
					})}
				</tbody>
			</table>

			{showDelete !== 0 && (
				<div className="fixed top-0 left-0 bottom-0 right-0 z-50 bg-black/40 flex flex-col justify-center items-center">
					<MapMarkerConfirmDelete onClose={() => setShowDelete(0)} onDelete={handleDelete} />
				</div>
			)}

			<div className="w-full p-2 sticky -bottom-0.5 bg-gray-50">
				{props.items.length > 0 ? (
					<>
						Kopā: <b>{props.items.length}</b> ierakst{props.items.length === 1 ? "s" : "i"}
					</>
				) : (
					<>Nav neviena ieraksta</>
				)}
			</div>
		</div>
	);
};
